// extracted by mini-css-extract-plugin
export default {"footerCells":"card-stats-table_footerCells__0y149"};